import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=0738a6fd&"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports